import React from 'react';
import Loadable from 'react-loadable';
import Loader from 'desktop/components/Common/BlankLoader.js';

const CompareLooksLoadable = Loadable({
    loader: () => import('desktop/containers/CompareLooks/CompareLooks.js' /* webpackChunkName: 'compareLooks' */).then(module => module.default),
    loading: () => <Loader />
});

export default CompareLooksLoadable;
